export const SECTION_NAME = 'Presets';
export const SELECTION_KEY = 'preset-entitlements';
export const NO_ASSIGNED_ENTITLEMENT_TITLE =
    'There are currently no resources assigned to this account. ' +
    'Please use the "Assign Resource(s)" button to assign access to a new resource.';

export const COLUMNS = {
    TITLE: 'title',
    DESCRIPTION: 'description',
    GRANT: 'grant',
    STATUS: 'status',
    RESTRICTION: 'restriction',
    USER_LEVEL: 'userLevel',
    ACCOUNT_LEVEL: 'accountLevel',
};

export const HEADERS = {
    [COLUMNS.TITLE]: 'Role/Resource',
    [COLUMNS.DESCRIPTION]: 'Description',
    [COLUMNS.GRANT]: 'Entitlement Grant',
    [COLUMNS.STATUS]: 'Status',
    [COLUMNS.RESTRICTION]: 'Restriction',
    [COLUMNS.USER_LEVEL]: 'User',
    [COLUMNS.ACCOUNT_LEVEL]: 'Account',
};

export const COLUMNS_DATA = [
    {
        columnId: COLUMNS.TITLE,
        fixed: true,
        defaultWidth: 450,
        minWidth: 400,
        maxWidth: 500,
    },
    {
        columnId: COLUMNS.DESCRIPTION,
        fixed: false,
        defaultWidth: 450,
        minWidth: 400,
        maxWidth: 500,
    },
    {
        columnId: COLUMNS.GRANT,
        fixed: false,
        defaultWidth: 400,
        minWidth: 350,
        maxWidth: 500,
    },
    {
        columnId: COLUMNS.STATUS,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 400,
    },
    {
        columnId: COLUMNS.RESTRICTION,
        fixed: false,
        defaultWidth: 260,
        minWidth: 260,
        maxWidth: 500,
    },
    {
        columnId: COLUMNS.USER_LEVEL,
        fixed: false,
        defaultWidth: 100,
        minWidth: 100,
        maxWidth: 100,
    },
    {
        columnId: COLUMNS.ACCOUNT_LEVEL,
        fixed: false,
        defaultWidth: 100,
        minWidth: 100,
        maxWidth: 100,
    },
];
